export declare namespace ActionMenuTokenSections {
	interface Title {
		fontSize: string;
		fontWeight: string;
	}
}

export type ActionMenuTokens = {
	background: string;
	title: ActionMenuTokenSections.Title;
};

export const title: ActionMenuTokenSections.Title = {
	fontSize: '1.125rem',
	fontWeight: '700',
};

export default {
	background: '{primary.50}',
	title,
} satisfies ActionMenuTokens;
